<div class="row align-items-center">
  <div class="col-8">
    <label [for]="id" class="toggle"><span>{{title}}</span></label>
  </div>
  <div class="col">
    <input type="checkbox" (input)="sendValue($event)" [id]="id" />
  </div>
</div>